export default "__VITE_ASSET__LAXfIzYg__"